
const endMessageMap = {
    'wincheckmate' : 'You checkmated your opponent.',
    'losecheckmate' : 'You got checkmated by your opponent.',
    'drawstalemate' : 'Game drawn by stalemate',
    'drawrepetition' : 'Game drawn by repetition',
    'drawtfr' : 'Game drawn by repetition',
    'draw50 moves rule' : 'Game drawn by the 50-move rule',
    'loseresignation' : 'You resigned the game',
    'winresignation' : 'Your opponent resigned',
    'losetimeout' : 'You lost on time',
    'wintimeout' : 'You won on time',
    'winabandonment' : 'Your opponent left the game'
}

export default function endMessage(result, detail) {
    return endMessageMap[result + detail];
    // TODO catch error
}








